import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AGENCY_OFFICERS_STORE_KEY, IAgencyOfficersDetailsState } from './agency-officer-store.state';

const state = createFeatureSelector<IAgencyOfficersDetailsState>(AGENCY_OFFICERS_STORE_KEY);

export const agencyOfficerDetailsState = createSelector(state, (state1: IAgencyOfficersDetailsState) => state1.agencyOfficer);
export const actionResult = createSelector(state, (state1: IAgencyOfficersDetailsState) => state1.actionResult);
export const isLoading = createSelector(state, (state1: IAgencyOfficersDetailsState) => state1.isLoading);
export const isImageLoading = createSelector(state, (state1: IAgencyOfficersDetailsState) => state1.isImageLoading);
